import { combineReducers } from 'redux';
import users from './usersReducer';
import questions from './questionsReducer';
import answers from './answerReducer';
import matrixQuestions from './matrixQuestionsReducer';
import questionBlocks from './questionBlocksReducer';
import recommendations from './recommendationsReducer';
import hiddenTags from './hiddenTagsReducer';
import categories from './categoriesReducer';
import subcategories from './subcategoriesReducer';
import universities from './universitiesReducer';
import provinces from './provincesReducer';
import cities from './citiesReducer';
import summaries from './summaryReducer';
import results from './resultsReducer';

export default combineReducers({
  users,
  questions,
  answers,
  matrixQuestions,
  questionBlocks,
  recommendations,
  hiddenTags,
  categories,
  subcategories,
  universities,
  provinces,
  cities,
  summaries,
  results,
});



// WEBPACK FOOTER //
// ./src/reducers/entities/index.js